<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="19"
  viewBox="0 0 24 19"
>
  <path
    fill="#EF5350"
    fill-rule="evenodd"
    d="M20.248 0c4.932 4.974 4.932 13.037 0 18.01l-1.392-1.404c4.163-4.198 4.164-11.004 0-15.203L20.248 0zm-2.783 2.807c3.395 3.424 3.395 8.974 0 12.396L16.074 13.8c2.626-2.647 2.626-6.941 0-9.59l1.39-1.403zM3.699 0l1.392 1.403c-4.164 4.199-4.163 11.005 0 15.203L3.699 18.01c-4.932-4.973-4.932-13.036 0-18.01zm2.784 2.807L7.875 4.21c-2.627 2.649-2.627 6.943 0 9.59l-1.392 1.403c-3.395-3.422-3.395-8.972 0-12.396zM13.32 7.66a1.913 1.913 0 0 1 0 2.69 1.873 1.873 0 0 1-2.667 0 1.913 1.913 0 0 1 0-2.69 1.874 1.874 0 0 1 2.667 0z"
  />
</svg>
